import React from 'react';
import './TituloComponent.css';



const TituloComponent = () => {
  return (
    <div className="title-container">
      <h1>Bem-vindo ao Bar Inteligente!</h1>
    </div>
  );
};

export default TituloComponent;
